/** Temporary helper for legacy SilkStart-imported orders (LEGACY-* ids). */

const LEGACY_ORDER_PREFIX = "LEGACY-";

function apiServerUrl(): string {
  const url = import.meta.env.VITE_API_SERVER_URL as string | undefined;
  return url?.replace(/\/$/, "") ?? "";
}

export function isLegacyImportedOrder(orderId: string | null | undefined): boolean {
  return !!orderId?.startsWith(LEGACY_ORDER_PREFIX);
}

function legacyInvoiceNumber(
  orderId: string,
  stripeInvoiceId?: string | null,
): string | null {
  const fromStripe = stripeInvoiceId?.trim();
  if (fromStripe) return fromStripe;
  const fromOrderId = orderId.replace(/^LEGACY-/i, "").trim();
  return fromOrderId || null;
}

/**
 * URL for the **Download PDF receipt** button on legacy order pages.
 * Proxied through our API so the PDF opens inline in a new tab (SilkStart's
 * `pdf_download` endpoint forces `Content-Disposition: attachment`).
 */
export function resolveLegacyReceiptPdfUrl(args: {
  orderId: string;
  stripeInvoiceId?: string | null;
}): string | null {
  if (!isLegacyImportedOrder(args.orderId)) return null;

  const invoiceNumber = legacyInvoiceNumber(args.orderId, args.stripeInvoiceId);
  if (!invoiceNumber) return null;

  const api = apiServerUrl();
  if (!api) return null;
  return `${api}/legacy/silkstart-invoice/${encodeURIComponent(invoiceNumber)}/pdf`;
}
